import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import batchActions from '../../../../actions/batch.actions';
import helper from '../../../../utils/helper';
import BatchReportsPage from './BatchReportsPage';
import lookupActions from '../../../../actions/lookup.actions';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { DialogBox } from '../../../UI/Modal';
import { reportActions } from '../../../../actions/report.actions';

class BatchReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      batchReports: [],
      errors: '',
      loading: false,
      isFetching: false,
      isFetchingReport: false,
      openModal: false,
      selectedRow: null,
    };
    this.columns = [
      { dataField: 'batchNumber', text: 'Batch Number', sort: true },
      { dataField: 'productName', text: 'Product Name', sort: true },
      { dataField: 'comments', text: 'Comments', sort: true },
    ];
    this.defaultSorted = [
      {
        dataField: 'batchNumber',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit batch',
          action: (row) =>
            this.props.history.push(
              `/reports/batch-reports/edit-batch-report?batchId=${row.id}`,
            ),
        },
        {
          name: 'Delete batch',
          action: (row) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.batch.batchReports !== prevState.batchReports) {
      state.batchReports = nextProps.batch.batchReports;
    }
    // if (nextProps.batch.loading !== prevState.isFetching) {
    //   state.isFetching = nextProps.batch.loading;
    // }
    // if (nextProps.report.isFetching !== prevState.isFetchingReport) {
    //   state.isFetchingReport = nextProps.report.isFetching;
    // }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.batch.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    this.setState({ loading: true }, () =>
      this.props.lookupActions
        .getDepartments()
        .finally(() => this.setState({ loading: false })),
    );
  }
  onChangeDept = (deptId) => {
    this.setState(
      { deptId, isFetching: true },
      async () =>
        await this.props.batchActions
          .getBatchReportsByDept(deptId)
          .finally(() => this.setState({ isFetching: false })),
    );
  };
  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };
  onDeleteBatchReport = async () => {
    this.setState(
      { openModal: false },
      async () =>
        await this.props.batchActions
          .deleteBatchReport(this.state.selectedRow.id)
          .then(
            async () =>
              await this.props.batchActions.getBatchReportsByDept(
                this.state.deptId,
              ),
          ),
    );
  };
  onGetReport = (batchId, format) => {
    this.setState(
      { isFetchingReport: true },
      async () =>
        await this.props.reportActions
          .getBatchReports(format, batchId)
          .finally(() => this.setState({ isFetchingReport: false })),
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <div className="content-inner">
            <Loading />
          </div>
        </Backend>
      );
    }
    return (
      <>
        <DialogBox
          isOpen={this.state.openModal}
          title="Delete batch report"
          body="Are you sure you want to delete this batch report?"
          yesBtnLabel="Delete"
          onYes={this.onDeleteBatchReport}
          noBtnLabel="Cancel"
          onCancel={this.onCancel}
        />
        <BatchReportsPage
          {...this.state}
          onChangeDept={this.onChangeDept}
          onGetReport={this.onGetReport}
          datagridProps={{
            columns: this.columns,
            defaultSorted: this.defaultSorted,
          }}
          ctxMenuOptions={this.ctxMenuOptions}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    batch: state.batch,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    batchActions: bindActionCreators(Object.assign({}, batchActions), dispatch),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BatchReports);
